export function AiConnectorExitViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    angularTemplate: require('./ai-connector-exit.view.html'),
  });
}
